import { render } from "./AddTweets.vue?vue&type=template&id=1dc7978e&scoped=true"
import script from "./AddTweets.vue?vue&type=script&lang=js"
export * from "./AddTweets.vue?vue&type=script&lang=js"

import "./AddTweets.vue?vue&type=style&index=0&id=1dc7978e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vizbi-frontend-test/vizbi-frontend-test/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1dc7978e"]])

export default __exports__